import { render, staticRenderFns } from "./FontsBody.vue?vue&type=template&id=0078e917&scoped=true&"
import script from "./FontsBody.vue?vue&type=script&lang=js&"
export * from "./FontsBody.vue?vue&type=script&lang=js&"
import style0 from "./FontsBody.vue?vue&type=style&index=0&id=0078e917&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0078e917",
  null
  
)

export default component.exports